/* import __COLOCATED_TEMPLATE__ from './color-selection.hbs.js'; */
import Component from '@ember/component';
import { computed } from '@ember/object';

/**
## color selection
`color-selection` groups together the hsv-color-picker, sq-input-hexrgb, and
sq-color-swatches into one cohesive component.

┌--------------------------------┐
|                                |
|        hsv-color-picker        |
|                                |
└--------------------------------┘
┌--------------------------------┐
|        sq-input-hexrgb         |
└--------------------------------┘
 Recommended colors
┌--------------------------------┐
|       sq-color-swatches        |
└--------------------------------┘

### Parameters
@param {string} [color] selected color to be displayed
@param {action} [onchange] action is sent whenever the user changes something
@param {boolean} [shouldShowGrayscaleChoices] use grayscale (instead of receipt colors)
@param {array} [additionalColors] any additional colors for recommendation
*/

const GRAYSCALE_COLORS = ['ffffff', 'fafafa', 'e6e6e6', 'cccccc', 'b3b3b3', '808080', '4d4d4d', '000000'];
const RECEIPT_COLORS = ['546476', 'a973a9', '456d9c', '5a97c4', '71b7bc', '9bbf6a', '8897a7', 'e76c6d', 'e38484', 'ed9356', 'e3b14d', '997c61'];

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: ['color-selection'],
  additionalColors: null,
  recommendedColors: computed('shouldShowGrayscaleChoices', 'additionalColors', function () {
    return [this.shouldShowGrayscaleChoices ? GRAYSCALE_COLORS : RECEIPT_COLORS, this.additionalColors].compact().flat().uniq();
  })
});